import { PageRequest } from "./PageRequest";

export class GetListByProjectIdRequest {
  /**
   * * Номер проекта
   */
  ProjectId!: number;
  /**
   * * Поиск
   */
  Search!: string;
  /**
   * * Пагинация
   */
  Page!: PageRequest;
  /**
   * * Номер рабочей области
   */
  NamespaceId?: string;
  constructor(obj?: Partial<GetListByProjectIdRequest>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
